<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. لوحة التحكم (تختفي عند الطباعة) -->
    <div class="card shadow-sm mb-4 no-print border-top-primary">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 text-primary fw-bold">
          <i class="fas fa-layer-group ms-2"></i> طباعة كشوف مناداة داخلية (مجمع للإدارة)
        </h5>
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-4">
            <label class="fw-bold small">الإدارة التعليمية</label>
            <select v-model="form.admin_id" class="form-select">
              <option value="">-- اختر الإدارة --</option>
              <option v-for="adm in administrations" :key="adm.id" :value="adm.id">{{ adm.dep_name }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="fw-bold small">اسم المادة</label>
            <input type="text" v-model="form.subject_name" class="form-control" placeholder="مثال: حاسب آلي">
          </div>
          <div class="col-md-4">
            <button @click="fetchReport" class="btn btn-primary w-100 fw-bold" :disabled="loading || !form.admin_id">
              <span v-if="loading" class="spinner-border spinner-border-sm"></span>
              <span v-else>عرض الكل</span>
            </button>
          </div>
        </div>
        <div class="mt-3 text-end pt-3 border-top" v-if="processedSchools.length > 0">
           <button @click="printReport" class="btn btn-dark px-5 fw-bold"><i class="fas fa-print ms-2"></i> طباعة</button>
        </div>
      </div>
    </div>

    <!-- 2. منطقة الطباعة -->
    <div id="printMe" v-if="processedSchools.length > 0">
      
      <!-- حلقة تكرار لكل مدرسة -->
      <div v-for="(school, sIndex) in processedSchools" :key="sIndex" class="school-section" style=" page-break-after: always;">
        
        <table class="table table-bordered border-dark text-center align-middle mb-0 custom-table">
            
            <!-- ======================================================= -->
            <!-- الرأس: سيتكرر تلقائياً في كل صفحة -->
            <!-- ======================================================= -->
            <thead>
                <!-- الصف الأول: الترويسة الرسمية (بدون حدود) -->
                <tr class="header-row border-0">
                    <td colspan="6" class="border-0 p-0">
                        <div class="header-content pt-2 pb-2">
                            <div class="row align-items-center text-center">
                                <div class="col-4 text-start pe-3">
                                    <h6 class="fw-bold m-0 fs-6">محافظة شمال سيناء</h6>
                                    <h6 class="fw-bold m-0 fs-6">  مديرية التربية والتعليم</h6>
                                    <h6 class="fw-bold m-0 fs-6"> {{ getAdminName() }}</h6>
                                </div>
                                <div class="col-4">
                                    <h3 class="fw-bold text-decoration-underline m-0 fs-4">كشف مناداة داخلي</h3>
                                    <div class="mt-1 badge bg-white text-dark border border-dark fs-3">
                                        {{ form.subject_name || '....................' }}
                                    </div>
                                </div>
                                <div class="col-4 text-end ps-3">
                                    <h6 class="fw-bold m-0 fs-6">العام الدراسي 2026</h6>
                                </div>
                            </div>

                            <!-- شريط المدرسة -->
                            <div class="school-info mt-2 border-top border-bottom border-2 border-dark py-1 bg-white d-flex justify-content-between px-3 align-items-center">
                                <h6 class="fw-bold m-0 fs-5">مدرسة: {{ school.school_name }}</h6>
                                <span class="badge border border-dark text-dark fw-bold">رقم المدرسة: {{ school.school_id }}</span>
                            </div>
                        </div>
                    </td>
                </tr>

                <!-- الصف الثاني: العناوين -->
                <tr class="bg-light">
                  
                    <th width="12%">رقم الجلوس</th>
                    <th width="35%">اسم الطالب</th>
                    <th width="15%">الديانة</th>
                    <th width="15%">ملاحظات</th>
                    <th width="15%">حالة الغياب</th>
                </tr>
            </thead>

            <!-- الجسم -->
            <tbody>
                <tr v-for="(student, stIndex) in school.students" :key="student.id">
                 
                    <td class="fw-bold fs-5 font-monospace">{{ student.Seating_No }}</td>
                    <td class="text-start pe-3 fw-bold fs-20">{{ student.Arabic_Name }}</td>
                    <td>{{ student.Moslem_Name }}</td>
                    <td class="text-start px-2 small fw-bold">
                         <div v-if="student.Damg_Status_id" class="d-inline-block small fw-bold border border-dark px-1 ms-1 rounded fs-20" style="margin-top: 7px; background-color: gray; color: white;">دمج : {{student.disability_type}}</div>
                        <div v-if="student.Stud_Type_Id == 2" class="d-inline-block small fw-bold border border-dark px-1 ms-1 rounded fs-20">منازل - معفى من امتحان الكمبيوتر</div>
                        <!-- <div v-if="student.Stud_Type_Id == 2" class="d-inline-block small fw-bold border border-dark px-1 ms-1 rounded fs-20">منازل  </div> -->
                    </td>
                    <td></td> <!-- خانة الغياب -->
                </tr>
            </tbody>

            <!-- الذيل: التوقيعات (تظهر في نهاية كل صفحة أو في نهاية الجدول) -->
            <tfoot>
                <tr class="footer-row border-0">
                    <td colspan="6" class="border-0 p-0">
                        <div class="page-footer mt-2 d-flex justify-content-between px-3 fw-bold small border-top pt-1">
                            <span>مدير المدرسة: ....................</span>
                            <span>مراقب اللجنة: ....................</span>
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>

        <!-- فاصل إجباري بعد كل مدرسة -->
        <div class="page-break"></div>

      </div>

    </div>
  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "SchoolCallingSheet",
  data() {
    return {
      loading: false,
      administrations: [],
      processedSchools: [], // هنا سنضع المدارس بطلابها كاملة بدون تقسيم يدوي
      form: { admin_id: "", subject_name: "" }
    };
  },
  mounted() {
    this.fetchAdmins();
  },
  methods: {
    async fetchAdmins() {
        const res = await api.get('getadmins');
        this.administrations = res.data;
    },
    
    async fetchReport() {
        this.loading = true;
        try {
            const res = await api.post('/admin/reports/admin-schools-students', { 
                admin_id: this.form.admin_id 
            });
            // نأخذ البيانات كما هي لأننا سنعتمد على المتصفح في التقسيم
            this.processedSchools = res.data;
            
        } catch(e) { alert("خطأ"); } 
        finally { this.loading = false; }
    },

    getAdminName() {
        const a = this.administrations.find(x => x.id == this.form.admin_id);
        return a ? a.dep_name : '';
    },

    printReport() { this.$htmlToPaper("printMe"); }
  }
};
</script>

<style scoped>
.border-top-primary { border-top: 4px solid #0d6efd; }
.font-monospace { font-family: 'Courier New', monospace; }

@media print {
    @page { size: A4 portrait; margin: 10mm; }
    .no-print { display: none !important; }
    #printMe { visibility: visible; position: absolute; left: 0; top: 0; width: 100%; }

    /* 1. تكرار الرأس والذيل */
    thead { display: table-header-group; }
    tfoot { display: table-footer-group; }
    tr { page-break-inside: avoid; }

    /* 2. فصل المدارس */
    .school-section {
        page-break-after: always;
        display: block;
    }

    /* 3. إخفاء حدود الخلايا المدمجة */
    .header-row td, .footer-row td { border: none !important; }

    /* 4. تنسيق الجدول */
    .custom-table th, .custom-table td {
        border: 1px solid #000 !important;
        font-size: 13pt;
        padding: 4px;
    }
    
    .bg-light { background-color: #f0f0f0 !important; -webkit-print-color-adjust: exact; }
}
</style>